import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";
import { ViewProfileScreen } from "../components";

export const Profile = () => {
  return (
    <ContentLayout title="Profile" showBackBtn>
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={<div>Only User can view this.</div>}
            allowedRoles={[ROLES.USER, ROLES.MERCHANT]}
          >
            <ViewProfileScreen />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
